import { FC } from 'react';

import { usePage } from '@inertiajs/react';

import { useResolvedTheme } from '../../hooks/useResolvedTheme';
import { Expansion, ProductType, Universe } from '../../types';

type PageProps = {
    currentUniverse: Universe;
    currentProductType: ProductType;
    currentExpansion: Expansion;
    releaseHighlights: Expansion[];
};

export const Banner: FC = () => {
    const {
        currentUniverse,
        currentProductType,
        currentExpansion,
        releaseHighlights,
    } = usePage<PageProps>().props;
    const resolvedTheme = useResolvedTheme();
    const heroBanner =
        resolvedTheme === 'dark'
            ? currentUniverse.hero_banner_dark
            : currentUniverse.hero_banner;

    const heroBannerStyle = heroBanner
        ? {
              backgroundImage: `url(${heroBanner})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
          }
        : undefined;

    if (currentProductType || currentExpansion) {
        return (
            <section className={`hidden bg-muted/30 py-4 md:block`}>
                <div className="container">
                    <div className="flex flex-col justify-between gap-4 md:flex-row">
                        <div>
                            {currentProductType && currentExpansion ? (
                                <h1 className="text-2xl font-bold">
                                    {currentProductType.name}{' '}
                                    {currentExpansion.name} —{' '}
                                    {currentUniverse.name}
                                </h1>
                            ) : currentProductType ? (
                                <h1 className="text-2xl font-bold">
                                    {currentProductType.name}{' '}
                                    {currentUniverse.name}
                                </h1>
                            ) : (
                                <>
                                    <h1 className="text-2xl font-bold">
                                        {currentUniverse.name}
                                    </h1>
                                    <p className="text-muted-foreground">
                                        {currentUniverse.description}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        );
    } else if (!releaseHighlights?.length) {
        return (
            <section
                className={`relative mx-auto hidden h-60 max-w-[1600px] py-8 md:block md:py-12 ${!heroBanner ? 'bg-gradient-to-r from-white to-purple-100' : ''}`}
                style={heroBannerStyle}
            >
                {heroBanner && <div className="absolute inset-0" />}
                <div className="relative z-10 container flex h-full items-center px-4">
                    <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
                        <div className="flex items-center gap-4">
                            <div className="text-foreground">
                                <h1 className="text-2xl font-bold md:text-3xl">
                                    {currentUniverse.name}
                                </h1>
                                <p className="mt-1 max-w-lg text-sm text-foreground/70 md:text-base">
                                    {currentUniverse.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return null;
};
